import React from 'react';
import { Divider } from 'antd';
import {
 Content,
 Head,
 ConnectName,
 Text,
 Title,
 DeviceName,
 NumberDevice,
} from '../../ModalStyled.styled';
import { Info } from './../../../../_assests';

export default function AcceptedInfo({ connectName, confirmError, data }) {
 const checkNumberDevice = data?.filter((item, idx) => {
  if (!confirmError) {
      return item;
  }
  return null;
 });

 return (
  <Content>
   <Head>
    <Info />
    <Title>Показания приняты</Title>
   </Head>
   <Divider />
   {checkNumberDevice?.map((item) => {
    return (
     <>
      <ConnectName>{connectName}</ConnectName>
      <DeviceName>Заводской номер прибора учета</DeviceName>
      <NumberDevice>{item.meteringDeviceNumber}</NumberDevice>
      <Text>Показания успешно приняты.</Text>
     </>
    );
   })}
  </Content>
 );
}
